module.exports = __webpack_public_path__ + "img/yixiuku.d1c040c2.svg";